<template>
    <div>
        <span v-html="$t('notification.automationUnpublished', {user: $_.get(activity, 'actorUser.name'), automation: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "AutomationUnpublished",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
